export default "__VITE_ASSET__04e008fb__"